import { useRef, type MutableRefObject, type RefObject } from 'react';

import type { StripeCardElementsGroup } from '../components/stripe-card-fields';

export interface PaymentFormRefs {
  wrapperRef: RefObject<HTMLDivElement>;
  card1GroupRef: MutableRefObject<StripeCardElementsGroup | null>;
  card2GroupRef: MutableRefObject<StripeCardElementsGroup | null>;
  splitFullLastRef: MutableRefObject<'1' | '2'>;
  splitDownLastRef: MutableRefObject<'1' | '2'>;
  prevDownForSplitRef: MutableRefObject<number | null>;
  prevSplitPayInFullRef: MutableRefObject<boolean | undefined>;
  prevSplitInstalmentDownRef: MutableRefObject<boolean | undefined>;
}

export function usePaymentFormRefs(): PaymentFormRefs {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const card1GroupRef = useRef<StripeCardElementsGroup | null>(null);
  const card2GroupRef = useRef<StripeCardElementsGroup | null>(null);
  const splitFullLastRef = useRef<'1' | '2'>('1');
  const splitDownLastRef = useRef<'1' | '2'>('1');
  const prevDownForSplitRef = useRef<number | null>(null);
  const prevSplitPayInFullRef = useRef<boolean | undefined>(undefined);
  const prevSplitInstalmentDownRef = useRef<boolean | undefined>(undefined);

  return {
    wrapperRef,
    card1GroupRef,
    card2GroupRef,
    splitFullLastRef,
    splitDownLastRef,
    prevDownForSplitRef,
    prevSplitPayInFullRef,
    prevSplitInstalmentDownRef,
  };
}
